export const LANDING_SCREEN_PATH = '/';
export const SEARCH_SCREEN_PATH = '/search';
export const FINDER_SCREEN_PATH = '/finder';
export const BOOK_SCREEN_PATH = '/book';
export const FAQ_SCREEN_PATH = '/faq';
export const MY_BOOKING_SCREEN_PATH = '/my-booking';
export const SUPPORT_SCREEN_PATH = '/support';
export const TERMS_SCREEN_PATH = '/terms';
export const CONTRACT_CUSTOMER = '/contract-customer';
export const APPLY_CONTRACT_CUSTOMER = '/apply';